<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 근로자 정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 근로자 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>부서명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" v-model="form.inputB_2" placeholder="선택" @select="targetCompany"></CompanySelector>
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" />
        </div>

        <div>
          <div>나이</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input v-else v-model="form.inputB_5" type="number" />
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputB_6" autocomplete>
            <vs-select-item v-for="option of options['구분']" :text="option" :value="option" :key="option" />
          </vs-select>
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputB_7" autocomplete>
            <vs-select-item v-for="option of options['직종']" :text="option" :value="option" :key="option" />
          </vs-select>
        </div>

        <div>
          <div>입사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <date-selector v-else v-model="form.inputB_8" :readonly="board.readonly" />
        </div>
        <div>
          <div>근속연수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_9 }}</p>
          <ml-input v-else v-model="form.inputB_9" type="number" placeholder="입사일로부터 현재까지 실시간 자동입력" :readonly="true" />
        </div>
<!--        <div>-->
<!--          <div>연락처</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputB_10 }}</p>-->
<!--          <ml-input v-else v-model="form.inputB_10" />-->
<!--        </div>-->
      </div>
    </div>

    <!--    근로자 기본정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 근로자 기본정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>키</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <ml-input v-else type="number" v-model="form.inputC_1" />
        </div>
        <div>
          <div>체중</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input v-else type="number" v-model="form.inputC_2" />
        </div>
        <div>
          <div>복용 중 약물</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input v-else v-model="form.inputC_3" />
        </div>

        <div>
          <div>음주</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input v-else v-model="form.inputC_4" />
        </div>
        <div>
          <div>흡연</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
          <ml-input v-else v-model="form.inputC_5" />
        </div>
        <div>
          <div>운동</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
          <ml-input v-else v-model="form.inputC_6" />
        </div>
      </div>
    </div>

    <!-- 사후관리 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="사후관리"
      :tableData="[
        {
          id: 'input1',
          title: '조치사항',
          type: 'select',
          selectData: ['건강상담', '보호구지급 및 착용지도', '추적검사', '근무 중 치료', '근로시간 단축', '작업전환', '근로제한 및 금지', '산재용양신청서 직접 작성 등 당해 근로자에 대한 직업병확진의뢰 안내', '기타'],
          placeholder: '선택',
        },
        { id: 'input2', title: '내용', type: 'text', placeholder: '내용' },
      ]"
      :isUnshift="true"
      v-model="form.사후관리"
    />

    <!-- 일반 검진-->
    <table361-general-checkup
      class="mt-5" :list="form['일반검진']" @updateList="updateList1" :isPrint="isPrint"
      :isReadonly="board.readonly" :determinationOptions="determinationOptions['일반검진']"
      :hide-row2="true" :hide-row3="true" :hide-row4="true"/>
    <!-- 일반 검진 파일첨부 -->
    <file-upload-module id="file_1" class="w-full mt-5" v-model="form['일반검진파일']" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 특수검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['특수검진']"
      @updateList="updateList5"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="특수검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['특수검진']"
      hide-row2 hide-row3 hide-row4
    />
    <!-- 특수검진 파일첨부 -->
    <file-upload-module id="file_2" class="w-full mt-5" v-model="form['특수검진파일']" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 배치전 검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['배치전 검진']"
      @updateList="updateList3"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치전 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치전 검진']"
      hide-row2 hide-row3 hide-row4
    />
    <!-- 배치전 검진 파일첨부 -->
    <file-upload-module id="file_3" class="w-full mt-5" v-model="form['배치전 검진파일']" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 배치후 검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['배치후 검진']"
      @updateList="updateList4"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치후 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치후 검진']"
      hide-row2 hide-row3 hide-row4
    />
    <!-- 배치후 검진 파일첨부 -->
    <file-upload-module id="file_4" class="w-full mt-5" v-model="form['배치후 검진파일']" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 건강상담-->
<!--    <table361-health-counseling class="mt-5" :list="form['건강상담']" @updateList="updateList2" :isPrint="isPrint" :isReadonly="board.readonly" />-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 건강상담</h5>
    </div>
    <!-- 건강상담 파일첨부 -->
    <file-upload-module id="file_5" class="w-full mt-5" v-model="form['건강상담파일']" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Table361GeneralCheckup from "@/components/Table361GeneralCheckup.vue";
import Table361HealthCounseling from "@/components/Table361HeathCounseling.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    Table361HealthCounseling,
    Table361GeneralCheckup,
    DateSelector,
    CompanySelector,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        "stdInfo": {},
        "inputB_1": "",
        "inputB_2": "",
        "inputB_3": "",
        "inputB_4": "",
        "inputB_5": "",
        "inputB_6": "",
        "inputB_7": "",
        "inputB_8": "",
        "inputB_9": "",
        "inputB_10": "",
        "inputB_11": "",
        "inputC_1": "",
        "inputC_2": "",
        "inputC_3": "",
        "inputC_4": "",
        "inputC_5": "",
        "inputC_6": "",
        "companyName": "",
        "fileList": [],
        "사후관리": [],
        "일반검진": [{}],
        "일반검진파일": [],
        "건강상담": [{}],
        "건강상담파일": [],
        "배치전 검진": [{}],
        "배치전 검진파일": [],
        "배치후 검진": [{}],
        "배치후 검진파일": [],
        "특수검진": [{}],
        "특수검진파일": [],
      },
      options: {
        구분: [
          "사무직",
          "현업 - 청소 등 유지관리",
          "현업 - 도로의 유지·보수 종사자",
          "현업 - 환경미화종사자",
          "현업 - 폐기물 수거처리",
          "현업 - 공원·녹지 유지관리",
          "현업 - 산림조사·보호",
          "현업 - 조리시설",
          "현업",
          "노동자",
          "청원경찰",
          "기타",
        ],
        직종: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
      },
      determinationOptions: {
        "일반검진": ["정상", "일반질환의심", "고혈압·당뇨병 질환의심", "유질환자"],
        "배치전 검진": ["A", "C1", "C2", "Cn", "D1", "D2", "Dn", "R"],
        "배치후 검진": ["A", "C1", "C2", "Cn", "D1", "D2", "Dn", "R"],
        "특수검진": ["A", "C1", "C2", "Cn", "D1", "D2", "Dn", "R"],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    updateList1(value) {
      this.form["일반검진"] = value;
    },
    updateList2(value) {
      this.form["건강상담"] = value;
    },
    updateList3(value) {
      this.form["배치전 검진"] = value;
    },
    updateList4(value) {
      this.form["배치후 검진"] = value;
    },
    updateList5(value) {
      this.form["특수검진"] = value;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
